import React from 'react';
import DfbRte from '../ui-kit/dfb_rte';
import Section from "./section"

const MTextHighlightAlternative = (props) => {
  return (
    <Section
      baseClass="m-TextHighlight m-TextHighlight--alternative"
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-TextHighlight-wrapper">
        <div className="m-TextHighlight-container">
          <blockquote className="m-TextHighlight-highlight">
            <strong className="m-TextHighlight-highlightBig">{props.data.highlight_number}</strong>
            <div className="m-TextHighlight-highlightSmall">{props.data.highlight_text}</div>
          </blockquote>
          <DfbRte text={props.data.text} add_class="m-TextHighlight-text" />
        </div>
      </div>
    </Section>
  );
}

export default MTextHighlightAlternative;
